import { createQueryKeys } from "@lukemorales/query-key-factory";
import type { Filters } from "./shared";

/**
 * Query keys for deck entity.
 */
export const deckKeys = createQueryKeys("deck", {
	all: null,
	records: (filters: Filters = {}) => ({
		queryKey: ["records", filters],
	}),
	record: (id: string) => ({
		queryKey: ["record", id],
	}),
});
